import './StickerItem.css';

export type StickerItemLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export type StickerItemProps = {
  iconSrc: string;
  iconLayout: StickerItemLayout;
  ariaLabel: string;
  onClick?: () => void;
};

/** One sticker icon (Figma s_1…g_5 slots). */
export function StickerItem({
  iconSrc,
  iconLayout,
  ariaLabel,
  onClick,
}: StickerItemProps) {
  const isClickable = onClick != null;
  const layoutStyle = {
    left: iconLayout.left,
    top: iconLayout.top,
    width: iconLayout.width,
    height: iconLayout.height,
  };

  if (!isClickable) {
    return (
      <img
        className="sticker-item__icon"
        src={iconSrc}
        alt=""
        draggable={false}
        aria-label={ariaLabel}
        style={layoutStyle}
      />
    );
  }

  return (
    <button
      type="button"
      className="sticker-item"
      aria-label={ariaLabel}
      onClick={onClick}
      style={layoutStyle}
    >
      <img className="sticker-item__icon" src={iconSrc} alt="" draggable={false} />
    </button>
  );
}
